import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LevelIcon } from '../Icons';
import SkillBlock from '../SkillBlock';
import { CompletedIcon, CurrentIcon } from '../Icons';

const CardWrapper = styled.div`
  background-color: ${({ active, theme }) => active ? theme.yellow : theme['light-yellow']};
  border-radius: 0.3rem;
  box-sizing: border-box;
  letter-spacing: 0.01rem;
  margin: 1rem 0;
  padding: 0.5rem 0 0;
  transition: background-color 0.2s;
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0 1rem;
`;

const CardBody = styled.div`
  font-size: 0.9rem;
  padding: 0 1rem 1rem;
`;

const CardPlaces = styled.div`
  > span {
    display: block;
  }
`;

const CardStatus = styled.div`
  margin: 1.2rem 0 ;
  display: flex;
  align-items: center;
  > svg {
    width: 20px;
    height: 20px;
    margin-left: 0.5rem;
  }
`;

const CardSkillsBlock = styled.div`
`;

const CardSkillLevel = styled.div`
  display: flex;
  align-items: center;

  > div {
    display: flex;
    width: 45px;
    margin-left: 0.5rem;
  }
`;

const CardSkillType = styled.div`
  display: flex;
  align-items: baseline;
`;

const CardCTA = styled.div`
  margin: 1.5rem 0;

  > a {
    color: black;
    border-bottom: 1px solid black;
    padding-bottom: 0.2rem;
    text-decoration: none;
  }
`;

const CardButton = styled.button`
  background-color: #FEBA46;
  border: none;
  border-radius: 0 0 0.3rem 0.3rem;
  box-sizing: border-box;
  cursor: pointer;
  margin: 1rem 0 0;
  padding: 0rem;
  text-align: center;
  width: 100%;

  > span {
    font-size: 1.4rem;
    line-height: normal;
  }
`;

const PathwayCard = ({ pathway, active, setActive }) => {
  const { t } = useTranslation();
  const {
    name,
    origin,
    destination,
    status,
    skillLevel,
    skillType,
    size,
    link,
  } = pathway;

  const statusIcon = {
    completed: <CompletedIcon />,
    current: <CurrentIcon />,
  }[status?.toLowerCase()];

  return (
    <CardWrapper
      active={active}
      onClick={() => setActive(pathway)}
    >
      <Title>{name}</Title>
      <CardBody>
        <CardPlaces>
          <span>
            {t('card.destination')}
            <strong>
              {t('card.destination_countries', { country: destination.map(d => d.label) })}
            </strong>
          </span>
          <span>
            {t('card.origin')}
            <strong>
              {t('card.origin_countries', { country: origin.map(d => d.label) })}
            </strong>
          </span>
        </CardPlaces>
        { active
          ? (
            <>
              <CardStatus>
                <span>{t('card.status', { status: status })}</span>
                {statusIcon}
              </CardStatus>
              <CardSkillsBlock>
                { skillLevel && (
                  <CardSkillLevel>
                    <span>{t('card.skill_level')}</span>
                    <div>
                      <LevelIcon level={skillLevel} />
                    </div>
                  </CardSkillLevel>
                )}
                { skillType && (
                  <CardSkillType>
                    <span>{t('card.skill_type')}</span>
                    <SkillBlock skill={skillType} />
                  </CardSkillType>
                )}
                { size && <span>{t('card.size', { size })}</span> }
              </CardSkillsBlock>
              <CardCTA>
                <a href={link} target="_blank" rel="noreferrer noopener">
                  {t('card.cta')}
                </a>
              </CardCTA>
            </>
          )
          : null
        }
      </CardBody>
      { !active
        ? (
          <CardButton>
            <span>&#43;</span>
          </CardButton>
        )
        : null
      }
    </CardWrapper>
  );
};

export default PathwayCard;
